module.exports = __webpack_public_path__ + "static/media/planningBoard.3b83be1c.jpg";